import { CircularProgress, Grid } from "@mui/material";
import { useState } from "react";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import useDisclosure from "@/hooks/use-disclosure";
import IntakePreviewModal, {
  IntakeFormSection,
} from "@/pages/app/provider/scheduling/appointment/encounter/content-section/intake-preview/IntakePreviewModal";
import AppointmentFormRowItem from "./components/AppointmentFormRowItem";
import { useAppointmentForms } from "./hooks/use-appointment-forms";
import {
  APPOINTMENT_FORMS_TEXT,
  APPOINTMENT_FORM_LABEL_COLOR,
} from "./appointment-additional-forms-constant";
import { AppointmentFormRow } from "./appointment-additional-forms-types";

export interface AppointmentAdditionalFormsProps {
  appointmentUuid?: string;
}

const AppointmentAdditionalForms = ({
  appointmentUuid,
}: AppointmentAdditionalFormsProps) => {
  const { groups, isLoading, isError, getIntakePreview } =
    useAppointmentForms(appointmentUuid);
  const intakePreviewDisc = useDisclosure();
  const [intakeSection, setIntakeSection] = useState<IntakeFormSection>();

  const handleView = (row: AppointmentFormRow) => {
    setIntakeSection(row.name as IntakeFormSection);
    intakePreviewDisc.open(getIntakePreview(row.name));
  };

  if (isLoading) {
    return (
      <Flex justifyContent="center" p={2}>
        <CircularProgress size={22} />
      </Flex>
    );
  }

  if (isError) {
    return (
      <Text color={APPOINTMENT_FORM_LABEL_COLOR} mt={1}>
        {APPOINTMENT_FORMS_TEXT.loadError}
      </Text>
    );
  }

  return (
    <>
      {groups.map((group) => (
        <Grid key={group.kind} item xs={12} container gap="0.65rem" mt={1}>
          {group.rows.length ? (
            group.rows.map((row) => (
              <AppointmentFormRowItem
                key={row.id}
                row={row}
                onView={handleView}
              />
            ))
          ) : (
            <Grid container alignItems="center">
              <Grid item xs={4.5}>
                <Text fontWeight="medium" color={APPOINTMENT_FORM_LABEL_COLOR}>
                  {group.label}
                </Text>
              </Grid>
              <Grid item xs={0.3}>
                <Text color={APPOINTMENT_FORM_LABEL_COLOR}>:</Text>
              </Grid>
              <Grid item xs={7.2}>
                <Text color={APPOINTMENT_FORM_LABEL_COLOR}>
                  {group.emptyText}
                </Text>
              </Grid>
            </Grid>
          )}
        </Grid>
      ))}

      <IntakePreviewModal
        disclosureHost={intakePreviewDisc}
        selectedSection={intakeSection ? [intakeSection] : undefined}
        _showTabs
      />
    </>
  );
};

export default AppointmentAdditionalForms;
